import React, { useState } from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import '../assets/styles/Main.scss';
import { PortfolioContent } from '../data/content';

interface MainProps {
  content: PortfolioContent['main'];
}

function Main({ content }: MainProps) {
  const [imageError, setImageError] = useState<boolean>(false);

  const cleanPhotoUrl = content.photoUrl.replace(/^\//, '');
  const photoSrc = process.env.PUBLIC_URL
    ? `${process.env.PUBLIC_URL}/${cleanPhotoUrl}`
    : `/${cleanPhotoUrl}`;

  return (
    <div className="container" id="about">
      <div className="about-section">
        <div className="image-wrapper">
          {!imageError ? (
            <img
              src={photoSrc}
              alt={content.name}
              className="avatar-img"
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="avatar-fallback" title={content.name}>
              P
            </div>
          )}
        </div>
        <div className="content">
          <div className="hero-greeting">Portfolio</div>
          <h1>{content.name}</h1>
          <div className="hero-roles">{content.roles}</div>
          <div className="hero-location">
            <LocationOnOutlinedIcon />
            <span>{content.location}</span>
          </div>
          <p className="hero-desc">{content.aboutShort}</p>

          <div className="hero-actions">
            <a
              href={content.cvUrl}
              target="_blank"
              rel="noreferrer"
              className="btn-cv"
            >
              <DownloadIcon />
              <span>{content.downloadCv}</span>
            </a>

            <a href="#projects" className="btn-projects">
              {content.seeProjects}
            </a>

            <div className="social-links">
              {content.social.github && (
                <a
                  href={content.social.github}
                  target="_blank"
                  rel="noreferrer"
                  title={`GitHub: ${content.social.github}`}
                >
                  <GitHubIcon />
                </a>
              )}
              {content.social.linkedin && (
                <a
                  href={content.social.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  title={`LinkedIn: ${content.social.linkedin}`}
                >
                  <LinkedInIcon />
                </a>
              )}
              {content.social.email && (
                <a
                  href={`mailto:${content.social.email}`}
                  title={`Email: ${content.social.email}`}
                >
                  <EmailIcon />
                </a>
              )}
              {content.social.email && (
                <a className="hero-email" href={`mailto:${content.social.email}`}>
                  {content.social.email}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;